


















































































































































































































































import DatePicker from '../common/DatePicker.vue';
import DragDropFileInput from '../common/DragDropFileInput.vue';
import Draggable from 'vuedraggable';

import {
  FormFieldTypeEnum,
  IFormFieldData,
  IEmployeeFormFieldOptionSubmissionData,
  IEmployeeFormFieldSubmissionData,
  IFormSectionData,
  IFormSectionFieldData
} from '@/models';

import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import { PropType } from 'vue';
import Proxyable from '@/mixins/proxyable';
import DeleteConfirmationDialog from '../common/DeleteConfirmationDialog.vue';

export interface IMoveDragData {
  moved: { element: IFormSectionFieldData; newIndex: number; oldIndex: number };
}

export interface IAddDragData {
  added: { element: IFormSectionFieldData; newIndex: number };
}

export interface IRemoveDragData {
  removed: { element: IFormSectionFieldData; oldIndex: number };
}

export default mixins(auth, Proxyable).extend({
  components: {
    DatePicker,
    DeleteConfirmationDialog,
    DragDropFileInput,
    Draggable
  },

  props: {
    value: Object as PropType<IFormSectionData>
  },

  inject: {
    //FormBuilderDetailPage view component
    formBuilder: {
      default: {}
    }
  },

  data() {
    return {
      FormFieldTypeEnum,
      deleteFieldDialog: false
    };
  },

  computed: {
    selectedFieldIndex: {
      get(): number {
        return (this as any).formBuilder.selectedFieldIndex;
      },
      set(val) {
        (this as any).formBuilder.selectedFieldIndex = val;
      }
    }
  },

  methods: {
    setSelectedIndex(index: number) {
      this.selectedFieldIndex = index;
    },

    reorderTemplateSectionFields(
      data: IMoveDragData | IAddDragData | IRemoveDragData
    ) {
      this.internalValue.section_fields = (this
        .internalValue as IFormSectionData).section_fields.map((fields, i) => {
        return {
          ...fields,
          order: i
        };
      });

      //when moving from one section to the other, this method gets called twice
      //added and remove data comes in but we only want to save on added
      if ((data as IRemoveDragData).removed) return;

      if ((data as IMoveDragData).moved) {
        const index = (data as IMoveDragData).moved.newIndex;
        this.setSelectedIndex(index);
      } else if ((data as IAddDragData).added) {
        const index = (data as IAddDragData).added.newIndex;
        this.setSelectedIndex(index);
      }

      this.$emit('save');
    },

    removeTemplateSectionField() {
      this.internalValue.section_fields.splice(this.selectedFieldIndex!, 1);
      this.cancelFieldDeleteDialog();
      this.$emit('save');
    },

    editTemplateSectionField() {
      this.$emit('openDrawer', this.selectedFieldIndex);
    },

    cancelFieldDeleteDialog() {
      this.deleteFieldDialog = false;
    },

    genRadioBtnOptionsValue(
      radio: IEmployeeFormFieldSubmissionData,
      submissons: IEmployeeFormFieldOptionSubmissionData[]
    ): IEmployeeFormFieldOptionSubmissionData {
      let value = submissons.find(submisson => submisson.option == radio.id);

      if (!value) {
        value = {
          option: radio.id
        } as IEmployeeFormFieldOptionSubmissionData;
      }

      return value;
    },

    genLabel(section_field: IFormSectionFieldData) {
      let label = (section_field.field_template as IFormFieldData).label;
      if (section_field.required) {
        label = `${label}*`;
      }
      return label;
    }
  }
});
